export const addImmeubles = (payload) => {
  return {
    type: "ADD_IMMEUBLES",
    payload: payload,
  };
};
